import React from "react";
import { LoadingSpinner } from "@/components/bnp-icons";
import { isVideo } from "./utils";

interface MediaPreviewProps {
  urls: string[];
  loadingStates: Record<string, boolean>;
  onLoad: (url: string) => void;
  onRemove?: (index: number) => void;
  removable?: boolean;
}

const MediaPreview: React.FC<MediaPreviewProps> = ({
  urls,
  loadingStates,
  onLoad,
  onRemove,
  removable = true,
}) => {
  if (!urls.length) return null;

  return (
    <div className="mt-6 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
      {urls.map((url, index) => (
        <div
          key={`${url}-${index}`}
          className="relative group rounded-xl overflow-hidden border border-gray-200 bg-white shadow-sm"
        >
          <div className="relative aspect-[5/4] w-full">
            {loadingStates[url] && (
              <div className="absolute inset-0 flex items-center justify-center bg-gray-100 animate-pulse z-10">
                <LoadingSpinner />
              </div>
            )}

            {isVideo(url) ? (
              <video
                src={url}
                controls
                muted
                playsInline
                className={`w-full h-full object-contain transition-opacity duration-300 ${
                  loadingStates[url] ? "opacity-0" : "opacity-100"
                }`}
                onLoadedData={() => onLoad(url)}
              />
            ) : (
              <img
                src={url}
                alt={`Media ${index + 1}`}
                className={`w-full h-full object-contain transition-opacity duration-300 ${
                  loadingStates[url] ? "opacity-0" : "opacity-100"
                }`}
                onLoad={() => onLoad(url)}
              />
            )}
          </div>

          {removable && (
            <button
              type="button"
              onClick={() => onRemove?.(index)}
              className="absolute top-2 right-2 bg-red-500 hover:bg-red-600 text-white rounded-full p-2 opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default MediaPreview;
